/*!jslint
  this
*/
jQuery(function ($) {
  "use strict";

  function appHeight() {
    var wh = $(window).innerHeight();
    document.documentElement.style
      .setProperty('--app-height', wh + 'px');

  }
  window.addEventListener('resize', appHeight)
  appHeight();

  var lastScrollTop = 0, delta = 15;
  $(window).scroll(function (event) {
    var st = $(this).scrollTop();

    if (Math.abs(lastScrollTop - st) <= delta)
      return;
    if ((st >= 50)) {
      $(".site-header").addClass('sticky');
    } else {
      $(".site-header").removeClass('sticky');
    }
    if ((st > lastScrollTop) && (lastScrollTop > 0)) {
      // downscroll code
      $(".site-header").addClass('hide-nav');

    } else {
      // upscroll code
      $(".site-header").removeClass('hide-nav');
    }
    lastScrollTop = st;
  });


});